module.exports = __webpack_public_path__ + "static/media/capa-light-1024.9cc31e0e.png";